import CurrencyModel from 'src/model/currency.model';

const usNumber = {
  en: {
    separator: ',',
    decimal: '.',
    precision: 2
  },
  fr: {
    separator: ',',
    decimal: '.',
    precision: 2
  }
};

const usDate = {
  en: {
    long: 'LLL',
    short: 'MM/DD/YYYY'
  },
  fr: {
    long: 'LLL',
    short: 'MM/DD/YYYY'
  }
};

const usCurrency: { en: CurrencyModel; fr: CurrencyModel } = {
  en: {
    country: 'US',
    symbol: '$',
    precision: 2,
    decimal: '.',
    separator: ',',
    format: '%s %v'
  },
  fr: {
    country: 'US',
    symbol: '$',
    precision: 2,
    decimal: '.',
    separator: ',',
    format: '%s %v'
  }
};

export const US = {
  currency: usCurrency,
  date: usDate,
  number: usNumber
};

const caNumber = {
  en: {
    separator: ',',
    decimal: '.',
    precision: 2
  },
  fr: {
    separator: ' ',
    decimal: ',',
    precision: 2
  }
};

const caDate = {
  en: {
    long: 'LLL',
    short: 'YYYY/MM/DD'
  },
  fr: {
    long: 'LLL',
    short: 'YYYY/MM/DD'
  }
};

const caCurrency: { en: CurrencyModel; fr: CurrencyModel } = {
  en: {
    country: 'CA',
    symbol: '$',
    precision: 2,
    decimal: '.',
    separator: ',',
    format: '%s %v'
  },
  fr: {
    country: 'CA',
    symbol: '$',
    precision: 2,
    decimal: ',',
    separator: ' ',
    format: '%s %v'
  }
};

export const CA = {
  currency: caCurrency,
  date: caDate,
  number: caNumber
};
